import { useCallback, useState } from 'react';

export const useDialogState = (initialOpen = false) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const openDialog = useCallback(() => setIsOpen(true), []);
  const closeDialog = useCallback(() => setIsOpen(false), []);

  return { isOpen, openDialog, closeDialog, setIsOpen };
};
